(() => {
  const summaries = new Map();
  const loadSummary = url => {
    if (!summaries.has(url)) {
      summaries.set(url, fetch(url, { credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('Product unavailable');
          return response.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const proof = doc.querySelector('.jupityr-product-header__reviews .jupityr-hero-proof');
          if (!proof) throw new Error('Review summary unavailable');
          return proof.textContent.replace(/\s+/g, ' ').trim();
        })
        .catch(error => { summaries.delete(url); throw error; }));
    }
    return summaries.get(url);
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-home-product-reviews]').forEach(async target => {
      if (target.dataset.reviewsLoaded) return;
      target.dataset.reviewsLoaded = 'pending';
      try {
        const text = await loadSummary(target.dataset.homeProductReviews);
        if (!text) throw new Error('Empty review summary');
        target.textContent = text;
        target.hidden = false;
        target.dataset.reviewsLoaded = 'true';
      } catch { delete target.dataset.reviewsLoaded; }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
